import React from 'react'
import { getSaveState } from '../../services/redux/savestate/savestate-selectors'
import { useAppDispatch, useAppSelector } from '../../hooks/reduxHooks'
import { openDialog } from '../../services/redux/savestate/savestate-actions'
import { Link, useNavigate, LinkProps } from 'react-router-dom'

interface LinkWrapperProps extends Omit<LinkProps, 'to'> {
    route?: string
    children: React.ReactNode
}

const LinkWrapper: React.FC<LinkWrapperProps> = ({ route, children, ...props }: LinkWrapperProps) => {
    const saveState = useAppSelector(getSaveState)
    const dispatch = useAppDispatch()
    const navigate = useNavigate()

    if (!route) return <>{children}</>

    const handleNavigation = (e: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
        if (!e.metaKey && e.button !== 1 && !e.ctrlKey) {
            if (saveState) {
                navigate(route)
            } else {
                dispatch(openDialog(route))
            }
        }
    }

    return (
        <Link {...props} style={{ color: 'inherit', textDecoration: 'inherit' }} to={route} onMouseDown={handleNavigation}>
            {children}
        </Link>
    )
}

export default LinkWrapper
